export default __webpack_public_path__ + "static/media/stkspan.e173a90b.png";